import PropTypes from "prop-types"
import { HelperShelfTrigger, HelperShelfMessage } from "components/helper_shelf"

const InputControl = ({
  data = {},
  type,
  text,
  name,
  htmlFor,
  checked,
  value,
  onSelect = () => null,
  inputClasses = "",
  labelClasses = "",
  disabled,
  wrapperClasses = "mb-1",
  helperMessage = null,
  helperMessageStyle = {}
}) => {
  const isCheckbox = type === "checkbox"
  const baseInputClass = isCheckbox ? "checkbox" : "radio"
  const baseLabelClass = isCheckbox ? "checkbox-label" : "radio-label"

  return (
    <div className={wrapperClasses}>
      <input
        type={type}
        className={`${baseInputClass} ${inputClasses}`}
        name={name}
        id={htmlFor}
        checked={checked}
        value={value}
        onChange={onSelect}
        disabled={disabled}
        onClick={e => e.stopPropagation()}
      />
      <label
        htmlFor={htmlFor}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role="checkbox"
        aria-checked={checked}
        onClick={e => e.stopPropagation()}
        onKeyPress={e => e.stopPropagation()}
        className={`${baseLabelClass} ${labelClasses}`}
        {...data}
      >
        {text}
      </label>

      {helperMessage && (
        <>
          <HelperShelfTrigger id={`helperShelf-${htmlFor}`} className="icon ml-4p" />
          <HelperShelfMessage id={`helperShelf-${htmlFor}`} style={helperMessageStyle}>
            {helperMessage}
          </HelperShelfMessage>
        </>
      )}
    </div>
  )
}

InputControl.propTypes = {
  type: PropTypes.oneOf(["checkbox", "radio"]),
  text: PropTypes.node,
  name: PropTypes.string,
  htmlFor: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  value: PropTypes.string,
  onSelect: PropTypes.func,
  inputClasses: PropTypes.string,
  labelClasses: PropTypes.string,
  wrapperClasses: PropTypes.string,
  helperMessage: PropTypes.string,
  helperMessageStyle: PropTypes.object,
  data: PropTypes.object
}

export default InputControl
